// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard-content {\n  height: 100%;\n   /* overflow-y: hidden; */\n}\n\n.cs-dashboard {\n  height: 100%;\n}\n\n.dashboard-toolbar-flex {\n  max-height: 100% !important;\n}\n\n.cs-dashboard-col.col {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.dashboard-stepper {\n  background: transparent !important;\n  box-shadow: none !important;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
